module.exports = __webpack_public_path__ + "media/3.8ba2df9d.mp4";